import { Toaster as Sonner } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:rounded-md group-[.toaster]:border group-[.toaster]:border-ok group-[.toaster]:bg-panel-2 group-[.toaster]:px-3.5 group-[.toaster]:py-2 group-[.toaster]:text-body-s group-[.toaster]:text-fg group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-hl group-[.toast]:text-hl-ink",
          cancelButton:
            "group-[.toast]:bg-line group-[.toast]:text-fg",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
